// window.LOCALE is passed from the backend via wp_localize_script()
export const locale = {
  short: window.MBS_LOCALIZE.locale.split('_')[0],
  long: window.MBS_LOCALIZE.locale.replace('_','-'),
};
